import * as types from "./types";
import * as api from "./api";

// Dashboard
export const fetchProviderDashboard = () => ({
  type: types.FETCH_PROVIDER_DASHBOARD_INIT,
  payload: api.fetchDashboard(),
});

// Profile
export const fetchProviderProfile = () => ({
  type: types.FETCH_PROVIDER_PROFILE_INIT,
  payload: api.fetchProfile(),
});

// Tasks List
export const fetchProviderTasks = (params = {}) => ({
  type: types.FETCH_PROVIDER_TASKS_INIT,
  payload: api.fetchTasks(params),
});

// Task Detail
export const fetchProviderTaskDetail = (taskId) => ({
  type: types.FETCH_PROVIDER_TASK_DETAIL_INIT,
  payload: api.fetchTaskDetail(taskId),
});

// Start Task
export const startProviderTask = (taskId) => ({
  type: types.START_PROVIDER_TASK_INIT,
  payload: api.startTask(taskId),
});

// Complete Task
export const completeProviderTask = (taskId, data) => ({
  type: types.COMPLETE_PROVIDER_TASK_INIT,
  payload: api.completeTask(taskId, data),
});

// Upload Photo
export const uploadTaskPhoto = (taskId, formData) => ({
  type: types.UPLOAD_TASK_PHOTO_INIT,
  payload: api.uploadTaskPhoto(taskId, formData),
});

// Clear states
export const clearProviderTaskDetail = () => ({
  type: types.CLEAR_PROVIDER_TASK_DETAIL,
});

export const clearProviderError = () => ({
  type: types.CLEAR_PROVIDER_ERROR,
});
